import { ThemeCode } from '@tink/config/src/tinkLinkConfig';

export const theming = {
  resolveThemePreference: (): ThemeCode => {
    const userPrefersDark =
      window.matchMedia('(prefers-color-scheme: dark)').matches && ThemeCode.DARK;
    const userPrefersLight =
      window.matchMedia('(prefers-color-scheme: light)').matches && ThemeCode.LIGHT;
    const themeFromSystem = userPrefersDark || userPrefersLight;

    return themeFromSystem || ThemeCode.LIGHT;
  },
  getThemeLogo: (file: string, url: string) => {
    // Check if file or URL exists. Prioritize file over URL
    const modifiedFileName = `data:image/png;base64,`;

    return file ? `${modifiedFileName}${file.replace(modifiedFileName, '')}` : url;
  },
};
